/*
 * TODO js-submit-on-change
 * Hey you!
 * If you consider using this, I suggest you use the `x-submit-on-change`
 * Alpine directive instead. See: assets/app_js/alpine/submitOnChange.js:5
 */

document
  .querySelectorAll(".js-submit-on-change input, .js-submit-on-change select")
  .forEach((element) => element.addEventListener("change", onChange));

function onChange(e) {
  e.preventDefault();
  e.stopPropagation();

  const formGroup = e.target.closest(".form-group");
  const apiUrl = formGroup?.dataset.commitUrl;

  if (apiUrl) {
    const method = formGroup.dataset.commitMethod || "POST";
    const data = {};
    data[e.target.getAttribute("name")] = e.target.checked;

    ajax({
      url: apiUrl,
      method: method,
      data: data,
      dataType: "json",
      error: function () {
        console.error(`Error in submit-on-change ${method} ${apiUrl}`);
      },
      success: function (data) {
        if (!data.success) {
          location.reload();
        } else {
          document.dispatchEvent(new CustomEvent("recompute_workflow"));
        }
      },
    });
  } else {
    e.target.closest("form").submit();
  }
}
